import React from 'react';

// Lives here (not packages/shared) so packages/shared/components/dropdown/label.jsx
// doesn't depend on an app-local src/svg/down-arrow. Duplicated (intentionally) from
// apps/admin/src/svg/down-arrow.tsx, which previously carried a "kept for shared"
// compatibility comment for this exact reason.
// See docs/packages-common-migration/phase-0-findings.md section 6c.
export default function DownArrowIcon(props) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 50' {...props}>
      <path
        d='M25 40.09A3.48 3.48 0 0 1 25 45a3.4 3.4 0 0 1-4.85 0L1 25.45a3.49 3.49 0 0 1 0-4.89L20.15 1A3.4 3.4 0 0 1 25 1a3.48 3.48 0 0 1 0 4.89L9.29 23z'
        fill='#6d747b'
      />
    </svg>
  );
}
